var map = {
	"./de": [
		"eMJj",
		0
	],
	"./de.js": [
		"eMJj",
		0
	],
	"./en": [
		"4deE",
		1
	],
	"./en.js": [
		"4deE",
		1
	],
	"./es": [
		"gxqu",
		2
	],
	"./es.js": [
		"gxqu",
		2
	],
	"./fr": [
		"r2+X",
		3
	],
	"./fr.js": [
		"r2+X",
		3
	],
	"./it": [
		"ZeHe",
		4
	],
	"./it.js": [
		"ZeHe",
		4
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "wzZg";
module.exports = webpackAsyncContext;